//@ts-check
export class AttributeUtils {
  /**
   * Converting the incoming value to boolean. It is handly the framework specific and native way of boolean attribute sets.
   * @static
   * @param {unknown} value
   * @returns {boolean}
   */
  static convertToBoolean(value) {
    return value !== undefined && value !== null && value !== false && value !== "false";
  }

  /**
   * Converts the incoming value to string. If it is not valid it will be return an empty string.
   * @static
   * @param {unknown} value
   * @returns {string}
   */
  static convertToString(value) {
    if (typeof value === "object" && value !== null) {
      return JSON.stringify(value);
    }

    return value !== undefined && value !== null ? value.toString() : "";
  }

  /**
   * Converts the incoming value to array. If it is not valid, it will return an empty array.
   * If it is not valid it will be return with an empty array.
   * @static
   * @template T
   * @param {unknown} value
   * @returns {T[]|[]}
   */
  static convertToArray(value) {
    let parsedValue = value;

    if (typeof parsedValue === "string") {
      try {
        parsedValue = JSON.parse(/** @type {String} */(value));
      } catch (err) {
        return [];
      }
    }

    if (Array.isArray(parsedValue)) {
      return parsedValue;
    }

    return [];
  }

  /**
   * Converts the incoming value to object. If it is not valid, it will return an empty object.
   * If it is not wall it will be return with an empty object.
   * @static
   * @template T
   * @param {unknown} value
   * @returns {Record<string, T>|{}}
   */
  static convertToObject(value) {
    let parsedValue = value;

    if (typeof parsedValue === "string") {
      try {
        parsedValue = JSON.parse(/** @type {String} */(value));
      } catch (err) {
        return {};
      }
    }

    if (typeof parsedValue === "object" && !Array.isArray(parsedValue)  && parsedValue !== null) {
      return parsedValue;
    }

    return {};
  }
}
